export const stats = [
  {
    label: '收录平台与社区',
    value: '186',
    note: '覆盖综合、消费、财经、城市等 8 大类别',
  },
  {
    label: '最近一次核验',
    value: '2026.09',
    note: '每月对失效入口做一次集中清理',
  },
  {
    label: '发布指南条目',
    value: '24',
    note: '从材料整理到投递跟进的完整流程',
  },
  {
    label: '累计帮到的人',
    value: '57 万+',
    note: '按站内指南访问量粗略统计',
  },
];